export const ICON_SIZES = {
    xxsmall: 'xxsmall',
    xsmall: 'xsmall',
    small: 'small',
    middle: 'middle',
    large: 'large',
    xl: 'xl',
};
export const STROKE_WIDTH_DEFAULT = 2;
//TODO:  https://lucidlink.atlassian.net/browse/LUCID-17174
export const STROKE_WIDTH_SMALL = 2;
